import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ResultGetModel } from 'data/result/result.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: ResultGetModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<ResultGetModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const resultSlice = createSlice({
  name: 'result',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default resultSlice;
